export default {
	language: 'nl',
	licenseKey: 'GPL', 
	toolbar: {
		items: [
			'bold',
			'italic',
			'link',
			'style',
			'bulletedList',
			'numberedList',
			'heading',
			'insertTable',
			'blockQuote',
		]
	},
	style: {
		definitions: [
			{
				name: 'Primaire knop',
				element: 'a',
				classes: ['btn', 'btn-primary']
			},{
				name: 'Secondaire knop',
				element: 'a',
				classes: ['btn', 'btn-secondary']
			}
		]
	},
	table: {
		contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties',
            'toggleTableCaption'
        ]
	},
	htmlSupport: {
		allow: [
			{ name: 'a', classes: true }
		]
	},
	link: {
		decorators: {
			openInNewTab: {
				mode: 'manual',
				label: 'Openen in een nieuw venster?',
				defaultValue: true,
				attributes: {
					target: '_blank'
				}
			}
		}
	}
};